export const getTextLines = (lines) => {
    const textLines = [];
    lines.forEach((line) => textLines.push(line.map((subline) => subline.text).join('')));
    return textLines;
};
export const missesTrailingSpace = (subline) => {
    const sublineLastChar = subline.text.charAt(subline.text.length - 1);
    return sublineLastChar !== ' ';
};
